import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 8l8 4l8 -4l-8 -4l-8 4","key":"svg-0"}],["path",{"d":"M12 16l-4 -2l-4 2l8 4l8 -4l-4 -2l-4 2","fill":"currentColor","key":"svg-1"}],["path",{"d":"M8 10l-4 2l4 2m8 0l4 -2l-4 -2","key":"svg-2"}]]

const IconStackBack = createReactComponent('outline', 'stack-back', 'StackBack', __iconNode);

export default IconStackBack;